// extracted by mini-css-extract-plugin
export default {"team":"Team_team__iTjPG","card-container":"Team_card-container__p5sF2","dark":"Team_dark__e5i-q"};